import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { Row, Col, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomField from "components/form/CustomField";
import { useQueryParam } from "hooks/useQueryParam";
import { useSmartBack } from "hooks/useSmartBack";
import { getVehicleMakeValidationSchema } from "utils/validations";
import { handleSubmitForm } from "helpers/apiUtils";
import {
  addVehicleMake,
  getVehicleMakeDetails,
  updateVehicleMake,
} from "store/slices/vehicleMakeSlice";
import { usePermission } from "hooks/usePermission";
import PageHeader from "components/common/PageHeader";

const AddEditMake = ({ mode }) => {
  const { t } = useTranslation();
  const id = useQueryParam("id");
  const isEdit = mode === "edit";
  const goBack = useSmartBack();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    isLoading,
    loading,
    itemDetails: makeDetails,
  } = useSelector((state) => state.VehicleMake);
  const { canAction } = usePermission();
  const { canAdd, canEdit } = canAction("vehicles");

  const [initialValues, setInitialValues] = useState({
    name: {
      en: "",
      ar: "",
    },
  });
  useEffect(() => {
    if (isEdit && id) {
      dispatch(getVehicleMakeDetails(id));
    }
  }, [isEdit, id, dispatch]);

  useEffect(() => {
    if (isEdit && id) {
      const { name } = makeDetails;
      setInitialValues({
        name: {
          en: name?.en || "",
          ar: name?.ar || "",
        },
      });
    }
  }, [isEdit, id, dispatch, makeDetails]);

  const handleSubmit = (values) => {
    const payload = {
      name: {
        en: values.name.en,
        ar: values.name.ar,
      },
    };
    if (isEdit) {
      const updatedPayload = {
        ...payload,
        id,
      };
      handleSubmitForm({
        dispatch,
        action: updateVehicleMake,
        payload: updatedPayload,
        onSuccess: () => navigate(-1),
      });
    } else {
      handleSubmitForm({
        dispatch,
        action: addVehicleMake,
        payload,
        onSuccess: () => navigate(-1),
      });
    }
  };
  if (!canEdit && isEdit) return null;
  if (!canAdd && !isEdit) return null;

  if (isEdit && loading)
    return (
      <div className="g_center my-5">
        <Spinner />;
      </div>
    );
  return (
    <div className="page-content">
      <PageHeader
        isBackBtn={true}
        title={isEdit ? t("Edit Vehicle Make") : t("Add Vehicle Make")}
      />
      <div className="common_card">
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={getVehicleMakeValidationSchema(t, isEdit)}
          onSubmit={handleSubmit}
        >
          {() => (
            <Form>
              <Row>
                <Col lg={6}>
                  <div className="form_field">
                    <CustomField
                      label={t("Name EN")}
                      name="name.en"
                      placeholder={t("Enter Name EN")}
                      enableTranslate
                      translateTo="ar"
                      targetField="name.ar"
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="form_field">
                    <CustomField
                      label={t("Name AR")}
                      name="name.ar"
                      placeholder={t("Enter Name AR")}
                      className="rtl"
                      enableTranslate
                      translateTo="en"
                      targetField="name.en"
                    />
                  </div>
                </Col>

                <Col lg={12} className="d-flex justify-content-end gap-2 mt-3">
                  <button
                    type="button"
                    className="main_btn outline"
                    onClick={goBack}
                  >
                    {t("Cancel")}
                  </button>

                  <button
                    type="submit"
                    className="main_btn"
                    disabled={isLoading}
                  >
                    {isEdit ? t("Save Changes") : t("Add Vehicle Make")}
                  </button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AddEditMake;
